module.exports = __webpack_public_path__ + "img/hy0.350d72c8.jpg";